/**
 * Created by koqiui on 2017-04-09.
 */
import { MsgBox, Vue, Routes } from '../../app.vues';
import { Utils } from '../../app.base'
//

import SwbRetailerOrgTree from './RetailerOrgTree';
Vue.regist(SwbRetailerOrgTree);

import SwbRetailerShopListForSelect from './RetailerShopListForSelect';
Vue.regist(SwbRetailerShopListForSelect);

import SwbRetailerForComnSelect from './RetailerForComnSelect';
Vue.regist(SwbRetailerForComnSelect);

import SwbRetailerRentForSelect from './RetailerRentForSelect';
Vue.regist(SwbRetailerRentForSelect);

import SwbOrgForSelect from './OrgForSelect';
Vue.regist(SwbOrgForSelect);

//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openRetailComTreeSelectDlg(dlgConfig = {}, callback) {
    //
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let title = dlgConfig['title'] || "买家公司--选择";
    let enableSearch = dlgConfig['enableSearch'] || null; // 是否可以搜索
    let isRadio = dlgConfig['isRadio'] || false; // 是否可以单选
    let isShowIcon = dlgConfig['isShowIcon'] || false; // 是否可以伸缩
    let accordion = dlgConfig['accordion'] || false; // 是否手风琴模式
    let merchantId = dlgConfig['comId'] || null; // 零售商商户id
    let isCom = dlgConfig['isCom'] || false;
    let bizDepart = dlgConfig['bizDepart'] || false;
    let showIncludeClosed = dlgConfig['showIncludeClosed'];
    let defalultState = dlgConfig['defalultState'] || [1,3];
    //
    Vue.$showDialog({
        title: title,
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-retail-org-tree :defalultState="defalultState" :showIncludeClosed="showIncludeClosed" :bizDepart = "bizDepart" :enableSearch="enableSearch" :isCom="isCom" :isRadio="isRadio" :isShowIcon="isShowIcon" :accordion="accordion" :merchantId="merchantId" ref="swb_retail_org_tree"></swb-retail-org-tree>' +
        '</div>',
        data: {
            enableSearch: enableSearch,
            isRadio: isRadio,
            isShowIcon: isShowIcon,
            accordion: accordion,
            merchantId: merchantId,
            isCom: isCom,
            bizDepart: bizDepart,
            showIncludeClosed: showIncludeClosed,
            defalultState: defalultState
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retail_org_tree.getDlgResult() || {};
            if(result.type == "info") {
                let retailerCom = result.data;
                //
                callback(retailerCom);
            } else {
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

/**
 * 零售商机构多选
 * @param dlgConfig
 * @param displayDataList
 * @param callback
 */
import SwbRetailerOrgTreeMultiSelect from './RetailerOrgTreeMultiSelect';
Vue.regist(SwbRetailerOrgTreeMultiSelect);
export function openRetailerOrgTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let merchantId = dlgConfig['merchantId'];
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let showCheckboxLevel3 = dlgConfig['showCheckboxLevel3'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    let enableSearch = dlgConfig['enableSearch'] || null;
    let defaultCheckedItems = displayDataList || [];
    let bizDepart = dlgConfig['bizDepart'] || false;
    //
    Vue.$showDialog({
        title: '零售商机构 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        template: '<swb-retailer-com-tree-multi-select :bizDepart="bizDepart" :merchantId="merchantId" :enableSearch="enableSearch" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :showCheckboxLevel3="showCheckboxLevel3" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_retailer_org_tree_multi_select"></swb-retailer-com-tree-multi-select>',
        data: {
            merchantId: merchantId,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            showCheckboxLevel3: showCheckboxLevel3,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model,
            enableSearch: enableSearch,
            bizDepart : bizDepart
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_org_tree_multi_select.getDlgResult() || {};
            if(result.type == "info") {
                let comList = result.data;
                //
                // console.log(comList);
                callback(comList);
            } else {
                return false;
            }
        }
    });
}

export function openRetailerShopListForSelectDlg(dlgConfig = {}, callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let checkBox = dlgConfig['checkBox'];
    let filter = dlgConfig['filter'] || {};
    let checkedIds = dlgConfig['checkedIds'] || [];
    let checkedItems = dlgConfig['checkedItems'] || []; // 多选值
    let disableIds = dlgConfig['disableIds'] || [];
    let isRetailerRel = dlgConfig['isRetailerRel'];
    let title = dlgConfig['title'] != null ? dlgConfig['title'] : "零售商机构 - 选择";
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 900,
        height: 700,
        showCloseBtn: true,
        template: '<swb-retailer-shop-list-for-select :checkBox="checkBox" :filter="filter" :checkedItems="checkedItems" :checkedIds="checkedIds" :disableIds="disableIds" :isRetailerRel="isRetailerRel" ref="swb_retailer_shop_list_for_select"></swb-retailer-shop-list-for-select>',
        data: {
            checkBox: checkBox,
            filter: filter,
            checkedItems: checkedItems,
            checkedIds: checkedIds,
            disableIds: disableIds,
            isRetailerRel: isRetailerRel
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_shop_list_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let retailerShop = result.data;
                //
                callback(retailerShop, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

export function openRetailerShopListRelServicerForSelectDlg(dlgConfig = {}, callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let checkBox = dlgConfig['checkBox'];
    let filter = dlgConfig['filter'] || {};
    let checkedIds = Utils.merge([], dlgConfig['checkedIds']) || [];
    let disableIds = dlgConfig['disableIds'] || [];
    let isRetailerRel = dlgConfig['isRetailerRel'];
    //
    let theDlg = Vue.$showDialog({
        title: '客户机构关系 - 选择',
        width: -300,
        height: 850,
        showCloseBtn: true,
        template: '<swb-org-for-select :checkBox="checkBox" :filter="filter" :checkedIds="checkedIds" :disableIds="disableIds" :isRetailerRel="isRetailerRel" ref="swb_org_for_select" ></swb-org-for-select>',
        data: {
            checkBox: checkBox,
            filter: filter,
            checkedIds: checkedIds,
            disableIds: disableIds,
            isRetailerRel: isRetailerRel
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_org_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let retailerShopIds = result.data;
                //
                callback(retailerShopIds, theDlg);
            } else {
                return false;
            }
        },
        cancelClicked: function () {
            callback(null, theDlg);
        }
    });
}

//选择零售商公共组件
/**
 * @param params
 * @param callback
 */
export function openRetailerSelectComnDlg(params, callback) {
    let showContract = params.showContract || false;
    let showOrder = params.showOrder || false;
    let showAmbilateralBizRel = params.showAmbilateralBizRel || false;
    let showBizRel = params.showBizRel || false;
    let showAdverseBizRel = params.showAdverseBizRel || false;
    let showNoScoreBizRel = params.showNoScoreBizRel || false;
    let showShieldedBizRel = params.showShieldedBizRel || false;
    let showAll = params.showAll || false;
    let showSearch = params.showSearch || false;
    let multiSelect = params.multiSelect == null ? true : params.multiSelect;
    let multiSelectDisabled = params.multiSelectDisabled || false;
    let filter = params.filter || {};
    let initCheckedId = params.initCheckedId || null;
    let initCheckedIds = params.initCheckedIds || [];
    let warnMessage = params.warnMessage == null ? true : params.warnMessage; // 警告提示（没有选择提示）
    if(!showContract && !showOrder && !showAmbilateralBizRel && !showBizRel && !showAdverseBizRel && !showNoScoreBizRel && !showShieldedBizRel && !showAll && !showSearch) {
        MsgBox.warning("至少展示一种类型的零售商!");
        return;
    }
    let title = params.title != null ? params.title : "零售商 - 选择";
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1000,
        height: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-retailer-for-comn-select :showContract="showContract" :showOrder="showOrder" :showAmbilateralBizRel="showAmbilateralBizRel"' +
        ':showBizRel="showBizRel" :showAdverseBizRel="showAdverseBizRel" :showNoScoreBizRel="showNoScoreBizRel" :showShieldedBizRel="showShieldedBizRel"' +
        ':showAll="showAll" :showSearch="showSearch" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled"  :filter="filter" :initCheckedId="initCheckedId"' +
        ':initCheckedIds="initCheckedIds" :warnMessage = "warnMessage" ref="swb_retailer_for_comn_select"></swb-retailer-for-comn-select>' +
        '</div>',
        data: {
            showContract: showContract,
            showOrder: showOrder,
            showAmbilateralBizRel: showAmbilateralBizRel,
            showBizRel: showBizRel,
            showAdverseBizRel: showAdverseBizRel,
            showNoScoreBizRel: showNoScoreBizRel,
            showShieldedBizRel: showShieldedBizRel,
            showAll: showAll,
            showSearch: showSearch,
            multiSelect: multiSelect,
            multiSelectDisabled: multiSelectDisabled,
            filter: filter,
            initCheckedId: initCheckedId,
            initCheckedIds: initCheckedIds,
            warnMessage: warnMessage
        },
        okClicked: function () {
            let result = this.$refs.swb_retailer_for_comn_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                let returnData = {};
                returnData.checkedIds = result.checkedIds || [];
                returnData.checkedId = result.checkedId || null;
                returnData.checkedList = result.data || [];
                callback(returnData, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}

export function openRentRetailerForSelectDlg(dlgConfig, callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let multiSelect = dlgConfig['multiSelect'];
    let checkedIds = Utils.merge([], dlgConfig['checkedIds']) || [];
    let checkedItem = dlgConfig['checkedItem'];
    let title = dlgConfig['title'] != null ? dlgConfig['title'] : "零售客户 - 选择";
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: 900,
        height: 850,
        showCloseBtn: true,
        template: '<swb-rent-retailer-list-select :multiSelect="multiSelect" :checkedIds="checkedIds" :checkedItem="checkedItem"  ref="swb_rent_retailer_list_select" ></swb-rent-retailer-list-select>',
        data: {
            multiSelect: multiSelect,
            checkedIds: checkedIds,
            checkedItem: checkedItem,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_rent_retailer_list_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                callback(result.data, theDlg);
            } else {
                return false;
            }
        },
    });
}

import SwbRetailerComListOfMineForSelect from './RetailerComListOfMineForSelect';
Vue.regist(SwbRetailerComListOfMineForSelect);
export function openRentRetailerComForSelectDlg(dlgConfig, callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let checkBox = Utils.isTrue(dlgConfig['checkBox']);
    let needDisabled = Utils.isTrue(dlgConfig['needDisabled']);
    let filter = dlgConfig['filter'] || {};
    let selectIds = Utils.merge([], dlgConfig['selectIds']) || [];
    let title = dlgConfig['title'] != null ? dlgConfig['title'] : "客户机构 - 选择";
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -300,
        height: 850,
        showCloseBtn: true,
        template: '<swb-retailer-com-list-of-mine-for-select :checkBox="checkBox" :needDisabled="needDisabled" :selectIds="selectIds" :filter="filter" ref="swb_retailer_com_list_of_mine_for_select" ></swb-retailer-com-list-of-mine-for-select>',
        data: {
            checkBox: checkBox,
            needDisabled: needDisabled,
            selectIds: selectIds,
            filter: filter
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_retailer_com_list_of_mine_for_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
    });
}

import SwbDevcRentRetailerListForSelect from './DevcRentRetailerListForSelect';
Vue.regist(SwbDevcRentRetailerListForSelect);
export function openDevcRentRetailerListForSelectDlg(dlgConfig = {}, callback) {
    if(Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if(typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let multiSelect = dlgConfig['multiSelect'];
    let checkedIds = Utils.merge([], dlgConfig['checkedIds']) || [];
    let checkedItem = dlgConfig['checkedItem'] || {};
    //
    let theDlg = Vue.$showDialog({
        title: '零售商 - 选择',
        width: 900,
        height: 850,
        showCloseBtn: true,
        template: '<swb-devc-rent-retailer-list-for-select :multiSelect="multiSelect" :checkedIds="checkedIds" :checkedItem="checkedItem" ref="swb_devc_rent_retailer_list_for_select" ></swb-devc-rent-retailer-list-for-select>',
        data: {
            multiSelect: multiSelect,
            checkedIds: checkedIds,
            checkedItem: checkedItem
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_rent_retailer_list_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let retailer = result.data;
                //
                callback(retailer, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/retailer/selectDlg.js
// module id = 35
// module chunks = 1